/**
 * Escape an regex search term 
 * so the word does not interfere with the regex expression
 * 
 * e.g. new RegExp("Hello.", "g") will look for "Hello!...blah blah"
 * But here we want to find the term "Hello." instead
 * 
 * @param str 
 */
export function escapeRegExp(str: string) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
}
